import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import URL from "../../../../constant/URL";
import TYPE from "../../../../constant/TYPE";
import { setLearningDataAction } from "../../../../redux/learningData";

const Jumper = ( props ) => {

  const history = useHistory();
  const location = useLocation();

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setLearningData = payload => { dispatch( setLearningDataAction( payload ) ) };

  useEffect( () => {
    const timer = setTimeout( jumpResult, 4000 );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  const jumpResult = () => {
    TYPE.LEARNING.COURSE === answeringQuestions.learningType && setLearningData( { answeringQuestionsComplete : true } );
    history.replace( {
      pathname : URL.LEARNING.RESULT,
      state : {
        ...location.state,
        isCompleteAnsweringQuestions : true
      }
    } );
  };

  return props.children || null;

};

export default Jumper;
